<template>
  <div>
    <div
      class="summary-section-button search"
      @click.stop="onClickSearch(search)"
    >
      <div class="bar" />
      <div class="search-title">
        {{ search }}
      </div>
      <img
        height="25"
        src="/search.png"
        class="right"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickViewSearchButton',
  props: {
    search: String,
  },
  methods: {
    onClickSearch(search) {
      this.$emit('search', search);
    },
  },
};
</script>

<style scoped lang="scss">
.summary-section-button {
  background-color: $surface-light;
  font-size: 15px;
  font-weight: bold;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  border: 1px solid $borders;
  border-radius: 5px;
  display: flex;
  text-align: start;

  &.search {
    padding: 0;
    justify-content: space-between;
    width: auto;
    margin: 0.4em 0.4em;
    background: $surface;
  }

  .search-title {
    padding: 14px;
    flex: 1 0 75%;
  }

  .right {
    padding: 14px;
  }

  .bar::before {
    content: "";
    border: 5px solid $related-searches-button;
    position: relative;
    border-radius: 6px 0 0 6px;
    display: inline-block;
    height: 85%;
  }
}
</style>
